import sanitizeHtml from 'sanitize-html'

export const sanitizeHtmlText = (html: string): string => {
  return sanitizeHtml(html, {
    allowedTags: [
      'p',
      'br',
      'strong',
      'em',
      'u',
      'b',
      'i',
      'span',
      'div',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'ul',
      'ol',
      'li',
      'blockquote',
      'hr',
      's',
      'del',
      'a',
      'img',
      'code',
      'pre',
      'table',
      'thead',
      'tbody',
      'tfoot',
      'tr',
      'td',
      'th',
    ],

    allowedAttributes: {
      '*': ['style', 'class'],
      a: ['href', 'title', 'target', 'rel'],
      img: ['src', 'alt', 'title', 'width', 'height'],
      table: ['border', 'cellpadding', 'cellspacing', 'width'],
      td: ['colspan', 'rowspan', 'width', 'height'],
      th: ['colspan', 'rowspan', 'width', 'height'],
      div: ['align'],
      p: ['align'],
    },

    allowedStyles: {
      '*': {
        color: [/^(?!.*url\()/],
        'background-color': [/^(?!.*url\()/],
        'font-size': [/^(?!.*url\()/],
        'font-family': [/^(?!.*url\()/],
        'font-weight': [/^(?!.*url\()/],
        'font-style': [/^(?!.*url\()/],
        'text-align': [/^(left|right|center|justify|start|end)$/],
        'text-decoration': [/^(?!.*url\()/],
        float: [/^(left|right|none)$/],
        width: [/^(?!.*url\()/],
        height: [/^(?!.*url\()/],
        border: [/^(?!.*url\()/],
        padding: [/^(?!.*url\()/],
        margin: [/^(?!.*url\()/],
      },
    },

    allowedSchemes: ['https', 'mailto'],

    allowedSchemesByTag: {
      a: ['https', 'mailto'],
      img: ['https'],
    },

    exclusiveFilter: frame => {
      if (frame.tag === 'a') {
        return !frame.text.trim()
      }
      return false
    },

    transformTags: {
      a: (_, attribs) => ({
        tagName: 'a',
        attribs: {
          ...attribs,
          target: '_blank',
          rel: 'noopener noreferrer',
        },
      }),
    },
  })
}

export const encodeHtml = (html: string): string => {
  const bytes = new TextEncoder().encode(html)
  const binary = Array.from(bytes, (b) => String.fromCodePoint(b)).join('')

  return btoa(binary)
}

export const prepareHtml = (template: string) => {
  const cleanHtml = sanitizeHtmlText(template)

  return encodeHtml(cleanHtml)
}

export const getTextFromHtml = (html: string): string => {
  const div = document.createElement('div')
  div.innerHTML = html
  return div.textContent || ''
}
